import { Link } from 'react-router-dom';
import { localizePath } from '../i18nRoutes';

export function HeroSection({ t, heroImages, currentSlide, setCurrentSlide, language }) {
  return (
    <section className="hero">
      <div className="hero-carousel">
        {heroImages.map((image, index) => (
          <div key={index} className={`hero-slide ${index === currentSlide ? 'active' : ''}`} style={{ backgroundImage: `url(${image})` }}></div>
        ))}
      </div>
      <div className="hero-overlay"></div>
      <div className="container hero-content">
        <h1 className="hero-title" data-testid="hero-title">{t.hero.title}</h1>
        <p className="hero-subtitle">{t.hero.subtitle}</p>
        <p className="hero-motto">{t.hero.motto}</p>
        <div className="hero-buttons">
          <Link to={localizePath('/travel', language)} className="btn btn-primary" data-testid="explore-tours-btn">{t.hero.exploreTours}</Link>
          <Link to={localizePath('/real-estate', language)} className="btn btn-secondary" data-testid="view-properties-btn">{t.hero.viewProperties}</Link>
        </div>
      </div>
      <div className="carousel-dots">
        {heroImages.map((_, index) => (
          <button key={index} className={`dot ${index === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(index)} aria-label={`Go to slide ${index + 1}`}></button>
        ))}
      </div>
    </section>
  );
}
